import * as helper from './../../../../../VX/View/Assets/Js/helper';
import {getPerson} from "./PeopleGetter";
import {replaceSmily} from "./Smilynator";
import {CDNHandler} from "../../../Assets/Js/CDNHandler";
import * as Events from "./Events";

let arsch = [];
let titten = [];
let hard = [];
let video = [];
let muschi = [];

for (let n = 1; n <= 10; n++) {
	arsch.push(`arsch${n}.jpg`);
	titten.push(`titten${n}.jpg`);
	hard.push(`hard${n}.jpg`);
	video.push(`video${n}.jpg`);
	muschi.push(`muschi${n}.jpg`);
}

helper.shuffleArray(arsch);
helper.shuffleArray(titten);
helper.shuffleArray(hard);
helper.shuffleArray(video);
helper.shuffleArray(muschi);

let guestName: string;

helper.addEventListener(window, Events.USERNAME_SELECTED, (data) => {
	guestName = data.detail.name;
});

export 	function textReplacer(text: string, username: string): string {
	let image;
	const person = getPerson(username);
	const chatroom = helper.$('#chatroom');
	const extender = helper.getData(chatroom, 'extender');
	const age = helper.getData(chatroom, 'age');
	const cdn = new CDNHandler();
	let cdnDomain = '';
	cdn.getCdnDomain()
		.then(domain => cdnDomain = domain);

	text = text.replace(/{user}/g, () => {
		return guestName;
	});

	text = text.replace(/{[fm]_model\d}/g, (placeholder) => {
		const person = getPerson(placeholder);

		return person.name;
	});

	text = text.replace(/{(ass|tits|hard|muschi)_pic}/g, (placeholder) => {
		switch (placeholder) {
			case '{ass_pic}':
				image = arsch.pop();
				break;
			case '{tits_pic}':
				image = titten.pop();
				break;
			case '{muschi_pic}':
				image = muschi.pop();
				break;
			case '{hard_pic}':
			default:
				image = hard.pop();
				break;
		}

		return `<br><img class="paytour" data-hostid="${person.id}" src="/VX/Chatroom/img/images${age}/${image}" alt="" /><br>`;
	})

	text = text.replace(/{video}/g, () => {
		image = video.pop();
		return `<br><div class="video paytour" data-hostid="${person.id}"><img src="/VX/Chatroom/img/images16/${image}" alt="" /><i class="fas fa-play-circle fa-6x"></i> </div><br>`;
	})

	text = text.replace(/{video:.+}/g, (found) => {
		const [, name] = found.substr(1, found.length-2).split(':');

		return `<br><video src="//${cdnDomain}/chatroom/${name}.mp4" class="realvideo" controls autoplay loop playsinline /><br>`;
	})

	text = text.replace(/{profile_link}/g, () => {
		const person = getPerson(username);

		return `<a href="https://www.visit-x.net/de/amateur/${person.name}/?${extender}" target="_blank">Mein Profil</a>`
	})

	text = text.replace(/{profile_pic}/g, () => {
		return `<br><img class="paytour" data-hostid="${person.id}" src="${person.avatar}" width="250" alt="" /><br>`;
	})

	text = replaceSmily(text);

	return text;
}
